import { useEffect, useState } from 'react';
import {
  KhaiBaoTamDungKhauHaoTSCD,
  KhaiBaoTamDungKhauHaoTSCDInput,
  KhaiBaoTamDungKhauHaoTSCDResponse
} from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

export const useKhaiBaoTamDungKhauHaoTSCD = (initialData: KhaiBaoTamDungKhauHaoTSCD[] = []) => {
  const [khaiBaoTamDungKhauHaoTSCDs, setKhaiBaoTamDungKhauHaoTSCD] = useState<KhaiBaoTamDungKhauHaoTSCD[]>(initialData);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { entity } = useAuth();

  const fetchKhaiBaoTamDungKhauHaoTSCD = async (): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    const response = await api.get<KhaiBaoTamDungKhauHaoTSCDResponse>(
      `/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_TAM_DUNG_KHAU_HAO_TSCD}/`
    );

    const mappedData: KhaiBaoTamDungKhauHaoTSCD[] = response.data.results;

    setKhaiBaoTamDungKhauHaoTSCD(mappedData);
    setIsLoading(false);
  };

  const addKhaiBaoTamDungKhauHaoTSCD = async (newDeclaration: KhaiBaoTamDungKhauHaoTSCDInput): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    try {
      console.log('newDeclaration', newDeclaration);
      const response = await api.post<KhaiBaoTamDungKhauHaoTSCD>(
        `/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_TAM_DUNG_KHAU_HAO_TSCD}/`,
        newDeclaration
      );
      const addedDeclaration = response.data;

      setKhaiBaoTamDungKhauHaoTSCD(prev => [...prev, addedDeclaration]);
    } catch (error) {
      console.error('Error adding temporary stop depreciation declaration:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const updateKhaiBaoTamDungKhauHaoTSCD = async (
    uuid: string,
    updatedDeclaration: KhaiBaoTamDungKhauHaoTSCDInput
  ): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    try {
      const response = await api.put<KhaiBaoTamDungKhauHaoTSCD>(
        `/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_TAM_DUNG_KHAU_HAO_TSCD}/${uuid}/`,
        updatedDeclaration
      );
      const updatedDeclarationData = response.data;

      setKhaiBaoTamDungKhauHaoTSCD(prev =>
        prev.map(declaration =>
          declaration.uuid === updatedDeclarationData.uuid ? updatedDeclarationData : declaration
        )
      );
    } catch (error) {
      console.error('Error updating temporary stop depreciation declaration:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const deleteKhaiBaoTamDungKhauHaoTSCD = async (uuid: string): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    try {
      await api.delete(`/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_TAM_DUNG_KHAU_HAO_TSCD}/${uuid}/`);
      setKhaiBaoTamDungKhauHaoTSCD(prev => prev.filter(declaration => declaration.uuid !== uuid));
    } catch (error) {
      console.error('Error deleting temporary stop depreciation declaration:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const refreshKhaiBaoTamDungKhauHaoTSCDs = async (): Promise<void> => {
    await fetchKhaiBaoTamDungKhauHaoTSCD();
  };

  useEffect(() => {
    fetchKhaiBaoTamDungKhauHaoTSCD();
  }, [entity?.slug]);

  return {
    khaiBaoTamDungKhauHaoTSCDs,
    isLoading,
    addKhaiBaoTamDungKhauHaoTSCD,
    updateKhaiBaoTamDungKhauHaoTSCD,
    deleteKhaiBaoTamDungKhauHaoTSCD,
    refreshKhaiBaoTamDungKhauHaoTSCDs
  };
};
